import { render, staticRenderFns } from "./InHouseMatchmaking.vue?vue&type=template&id=7a24ed78&scoped=true"
import script from "./InHouseMatchmaking.vue?vue&type=script&lang=js"
export * from "./InHouseMatchmaking.vue?vue&type=script&lang=js"
import style0 from "./InHouseMatchmaking.vue?vue&type=style&index=0&id=7a24ed78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a24ed78",
  null
  
)

export default component.exports